import { render } from "./ContactPage.vue?vue&type=template&id=910064fe"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"
script.render = render

export default script